import * as annotationTemplates from './annotationTemplates';
import * as base64Images from './base64Images';
import * as componentDesigns from './componentDesigns';
import * as jobs from './jobs';
import * as pdfPages from './pdfPages';
import * as pdfs from './pdfs';
import * as regions from './regions';
import * as seals from './seals';
import * as signatures from './signatures';

export default {
  annotationTemplates,
  base64Images,
  componentDesigns,
  jobs,
  pdfPages,
  pdfs,
  regions,
  seals,
  signatures,
};
